import { create } from 'zustand';

import { BlockingStep } from '@activepieces/shared';

type OpenArgs = { blockingSteps: BlockingStep[]; flowId: string };

type BlockingPiecesStore = {
  open: boolean;
  blockingSteps: BlockingStep[];
  flowId: string;
  openBlockingPieces: (args: OpenArgs) => void;
  setOpen: (open: boolean) => void;
};

export const useBlockingPiecesStore = create<BlockingPiecesStore>()((set) => ({
  open: false,
  blockingSteps: [],
  flowId: '',
  openBlockingPieces: ({ blockingSteps, flowId }) =>
    set({ open: true, blockingSteps, flowId }),
  setOpen: (open) => set({ open }),
}));
